import React from "react";
import { cn } from "@/lib/utils";
import { fontSize, fontWeight, textColor, borderColor, focusStyle } from "@/theme";

interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label?: string;
  icon?: React.ReactNode;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, label, icon, ...props }, ref) => {
    const hasError = error && error.length > 0;

    return (
      <div className="w-full">
        {label && (
          <label className={`block ${fontSize.sm} ${fontWeight.medium} ${textColor.secondary} mb-2`}>
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className={`absolute left-3 top-1/2 -translate-y-1/2 ${textColor.iconBlue}`}>
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={cn(
              `flex h-10 w-full rounded-lg border bg-white px-3 py-2 ${fontSize.sm} placeholder:${textColor.subtle} focus:outline-none ${focusStyle.primary} focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50`,
              hasError ? borderColor.error : borderColor.gray300,
              icon && "pl-10",
              className
            )}
            {...props}
          />
        </div>
        {hasError && (
          <p className={`${textColor.error} ${fontSize.sm} mt-1`}>{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";
